export var cachePrefix = 'xctm-0xd';
export var storageKey = 'xctm-0xd-enc';
